import { render, staticRenderFns } from "./ItemCharges.vue?vue&type=template&id=fa30788a&scoped=true&"
import script from "./ItemCharges.vue?vue&type=script&lang=ts&"
export * from "./ItemCharges.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCharges.vue?vue&type=style&index=0&id=fa30788a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30788a",
  null
  
)

export default component.exports